import { FlexView, Icon, Text } from '@components/Common';
import { Colors } from '@styles/system';
import { useResponsive } from '@utils/hooks';
import { useState } from 'react';

interface AccordionProps {
  title: string;
  content: string;
}

export default ({ title, content }: AccordionProps) => {
  const deviceType = useResponsive();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <FlexView
      css={{
        overflow: `hidden`,
        borderBottom: `0.5px solid ${Colors.secondary30}`,
      }}
    >
      <FlexView
        content="between"
        css={{
          cursor: `pointer`,
          height: deviceType === `P` ? `110px` : `64px`,
          // padding: `0 20px`,
        }}
        items="center"
        row
        onClick={() => setIsOpen(!isOpen)}
      >
        <Text color={Colors.white} xLarge={deviceType === `P`} bold>
          {title}
        </Text>
        <Icon
          color={isOpen ? Colors.primary : Colors.secondary}
          name={isOpen ? `arrowUp` : `arrowDown`}
          size={24}
        />
      </FlexView>
      {isOpen && (
        <FlexView
          css={{
            height: isOpen ? `auto` : 0,
            minHeight: isOpen ? `60px` : `0 !important`,
            transition: `min-height 0.5s ease-in-out`,
            padding: `0 20px`,
            marginBottom: `16px`,
          }}
        >
          <Text color={Colors.secondary70} multiLine>
            {content}
          </Text>
        </FlexView>
      )}
    </FlexView>
  );
};
